export const candidateFormFields = (statusList) => [
  {
    type: "text",
    name: "firstName",
    label: "First Name",
    validation: (value) => (!value ? "First name is required" : null),
  },
  {
    type: "text",
    name: "infix",
    label: "Infix",
  },
  {
    type: "text",
    name: "lastName",
    label: "Last Name",
    validation: (value) => (!value ? "Last name is required" : null),
  },
  {
    type: "email",
    name: "email",
    label: "Email Address",
    readOnly: true,
    validation: (value) => (!value ? "Email is required" : null),
  },
  {
    type: "phone",
    name: "phone",
    label: "Phone Number",
  },
  {
    type: "select",
    name: "status",
    label: "Status",
    options: Object.entries(statusList).map(([key, value]) => ({ key, value: (value as { name }).name })),
  },
];